import { render } from "./missingWord.vue?vue&type=template&id=3cbdf2ee&scoped=true"
import script from "./missingWord.vue?vue&type=script&lang=js"
export * from "./missingWord.vue?vue&type=script&lang=js"

import "./missingWord.vue?vue&type=style&index=0&id=3cbdf2ee&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cbdf2ee"]])

export default __exports__